import {createArrayIntentType} from '../intent';
import type {Intent} from '../intent';
import type {Style} from '../style/types';
import type {ConditionalObject} from '../util';

type TokenProperties = {
  tokens?: ConditionalObject<string> | undefined;
  tokenOverrides?: ConditionalObject<string> | undefined;
};
type TokenIntentInput = Style.Input<TokenProperties>;
export type TokenIntent = TokenIntentInput & Intent<never>;
type TokenGlobalIntentInput = Style.GlobalInput<TokenProperties>;
export type TokenGlobalIntent = TokenGlobalIntentInput & Intent<never>;

export const lazyTokenIntent = createArrayIntentType(
  'LazyTokenIntent',
  (decorate) =>
    (overrides: TokenIntentInput): TokenIntent =>
      decorate(overrides),
);

export const lazyGlobalTokenIntent = createArrayIntentType(
  'LazyGlobalTokenIntent',
  (decorate) =>
    (overrides: TokenGlobalIntentInput): TokenGlobalIntent =>
      decorate(overrides),
);
